'use strict';

import angular from 'angular';
import 'angular-cookies';
import 'angular-sanitize';
import posthog from 'posthog-js';

angular.module('lingApp', ['ngCookies', 'ngSanitize'], ['$rootScopeProvider', function($rootScopeProvider) {
  $rootScopeProvider.digestTtl(15);
}])

  .run(function($injector, $location, $rootScope, $window, RipServer, RipContext, i18n, RipEnum, RipRoute) {
    _.mixin({'isSpecified': function(a) { return null !== a && ('undefined' !== typeof a); }});

    if ('undefined' === (typeof $window.console)) {
      $window.console = {log: angular.noop };
    }

    posthog.init('phc_o0DIlZi6AQtgm0Ws0JdjM3aPfdFoResOmJWrII19stW',
                 { api_host: 'https://pa.apigateway.co',
                   loaded: function (posthog) {
                     posthog.identify(RipContext.userId);
                   },
                   autocapture: false
                 });

    RipServer
      .exec('/rip/launch/json/getL10n', { urlLocaleCode: RipRoute.getParam('localeCode') })
      .then(function(data) {
        RipContext.set(data, i18n);
      });
  });
